import Layout from '@layout/Index'

export const workInfoWorkType = [
  {
    path: '/work-info-work-type',
    component: Layout,

    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "WorkInfoWorkTypeTable" */ './pages/WorkInfoWorkTypeTable.vue'),
        name: '职业信息工种',
        meta: {
          title: '职业信息工种',
        },
      },
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "WorkInfoWorkTypeForm" */ './pages/WorkInfoWorkTypeForm.vue'),
        name: '新增职业信息工种',
        meta: {
          title: '新增职业信息工种',
        },
      },
      {
        path: 'update/:id',
        component: () => import(/* webpackChunkName: "WorkInfoWorkTypeForm" */ './pages/WorkInfoWorkTypeForm.vue'),
        name: '编辑职业信息工种',
        meta: {
          title: '编辑职业信息工种',
        },
      },
    ],
  },
]




// WEBPACK FOOTER //
// ./src/views/work-info-work-type/work-info-work-type.route.js